// extracted by mini-css-extract-plugin
module.exports = {"checkIcon":"_3wqMtGxiW2JgntTi3WE4lE"};